import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function MobileBookButton() {
  const loc = useLocation();
  const hiddenPaths = ["/book", "/admin", "/build"];
  if (hiddenPaths.includes(loc.pathname) || loc.pathname.startsWith("/my-booking")) return null;
  return (
    <Link
      to="/book"
      data-testid="mobile-persistent-book-btn"
      className="xl:hidden fixed bottom-5 right-5 z-40 btn-primary shadow-2xl"
      style={{ boxShadow: "0 20px 40px rgba(183, 93, 50, 0.35)" }}
    >
      Book Your Event <ArrowUpRight className="arrow" size={14} />
    </Link>
  );
}
